import React, { useState } from "react";
import { Layout } from "../components/Layout";
import { Hero } from "../components/Hero";
import { FeaturedDates } from "../components/FeaturedDates";
import { Explorer } from "../components/explorer/Explorer";
import { WhyItMatters } from "../components/WhyItMatters";
import { Preservation } from "../components/Preservation";
import { Resources } from "../components/Resources";
import { SubmitForm } from "../components/SubmitForm";
import { DateDetail } from "../components/DateDetail";
import { useDocumentMeta } from "../lib/useDocumentMeta";
import { useJsonLd } from "../lib/useJsonLd";
import { homePageJsonLd } from "../lib/jsonLd";

export const HomePage = () => {
  const [openEntry, setOpenEntry] = useState(null);

  useDocumentMeta({
    title: "Will Not Be Forgotten — A Living Civic Memory Archive",
    description: "A public-memory project preserving the U.S. holidays, observances, heritage months, and historic milestones that shape a fuller American story.",
    canonical: "https://willnotbeforgotten.org/",
  });
  useJsonLd(homePageJsonLd());

  return (
    <Layout>
      <Hero />
      <FeaturedDates onOpenDetail={setOpenEntry} />
      <Explorer onOpenDetail={setOpenEntry} />
      <WhyItMatters />
      <Preservation />
      <Resources />
      <SubmitForm />
      <DateDetail entry={openEntry} onClose={() => setOpenEntry(null)} />
    </Layout>
  );
};
